/**
 * Default timeout applied to the import / export / validator / recreate-transform worker threads.
 * Callers can override per-call via `options.timeoutMS`.
 */
export const DefaultWorkerTimeoutMS = 60000;

/**
 * The timeout for the worker to complete. Typically this will never be hit unless something goes very wrong.
 */
export const RecreateTransformWorkerTimeoutMS = DefaultWorkerTimeoutMS;

/**
 * The timeout for the worker to complete when creating transforms for flare docs.
 * This is a low value to quickly detect the RFC6902 patcher is going to take too long.
 */
export const RecreateTransformWorkerFlareTimeoutMS = 3000;
